export const formatProfileName = (first, second) => {
  return first.charAt(0) + second.charAt(0);
};
